import { Scripts as TScripts } from '../../types/contentstack';

export const PageScripts = ({
  nonce,
  scripts,
}: {
  nonce: string;
  scripts: TScripts;
}) => {
  const other: any[] = [
    `<script src="https://js.hsforms.net/forms/embed/v2.js"></script>`,
  ];

  const items = other?.concat(scripts?.items)?.map((item) => {
    return item?.replace(/<script/g, `<script nonce="${nonce}"`) || '';
  });

  return (
    <>
      <div id="page-scripts" style={{ display: 'none' }}>
        {JSON.stringify(items)}
      </div>
    </>
  );
};

/**
 * Loads the scripts from the #page-scripts container, which are added to the DOM after user consent. This is necessary because we cannot add the scripts directly to the page without user consent due to GDPR regulations, and we need to ensure that they are executed after being added to the DOM.
 */
export function loadPageScripts() {
  const container = document.getElementById('page-scripts');

  if (
    !container ||
    !container.textContent ||
    container.getAttribute('loaded') === 'true'
  ) {
    return;
  }

  const items = JSON.parse(container.textContent) as string[];

  container.textContent = '';

  const temp = document.createElement('div');
  temp.innerHTML = items.join('');

  const scriptElements = temp.querySelectorAll('script');

  scriptElements.forEach((oldScript) => {
    const newScript = document.createElement('script');

    Array.from(oldScript.attributes).forEach((attr) => {
      newScript.setAttribute(attr.name, attr.value);
    });

    newScript.textContent = oldScript.textContent;
    container.appendChild(newScript);
  });

  container.setAttribute('loaded', 'true');
}

export const GTMConversions = {
  signup: () => {
    (window as any)?.gtag?.('event', 'conversion', {
      send_to: 'AW-10978453293/m5zuCOyVtZkYEK3O9_Io',
    });
  },

  contact: () => {
    (window as any)?.gtag?.('event', 'conversion', {
      send_to: 'AW-10978453293/s5s0COmVtZkYEK3O9_Io',
    });
  },
};
